export default __webpack_public_path__ + "static/media/csvicon@2x.54a27e7d.png";